import React, { useState, useEffect } from "react";
import Navigation from "../components/Navigation";
import Hero from "../components/Hero";
import BusinessValue from "../components/BusinessValue";
import HowItWorks from "../components/HowItWorks";
import Benefits from "../components/Benefits";
import UseCases from "../components/UseCases";
import WorkWithUs from "../components/WorkWithUs";
import EarningsCalculator from "../components/EarningsCalculator";
import BuyMachine from "../components/BuyMachine";
import AboutUs from "../components/AboutUs";
import FAQ from "../components/FAQ";
import ContactForm from "../components/ContactForm";
import Footer from "../components/Footer";
import StickyCTA from "../components/StickyCTA";

const HomePage = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-[#0A0A0A]" data-testid="home-page">
      <Navigation isScrolled={isScrolled} />
      <main>
        <Hero />
        <BusinessValue />
        <HowItWorks />
        <Benefits />
        <UseCases />
        <WorkWithUs />
        <EarningsCalculator />
        <BuyMachine />
        <AboutUs />
        <FAQ />
        <ContactForm />
      </main>
      <Footer />
      <StickyCTA />
    </div>
  );
};

export default HomePage;
